/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, no-restricted-properties */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import moment from 'moment';
import { classNames } from '@ember-decorators/component';

const defaultSessionGap = 30;
const defaultSessionLength = 60;

@classNames('flex-45')
export default class SessionCard extends Component {
  @service
  store;

  date = null;
  event = null;
  onDelete = null;

  // canAddNewSession means the default next session would end before 00:00 (midnight)
  @computed('date.sessions.lastObject.endTime')
  get canAddNewSession() {
    let lastSessionEndTime = moment.unix(this.date.sessions.lastObject.endTime);
    let potentialSessionEndTime = moment(lastSessionEndTime).add(
      defaultSessionGap + defaultSessionLength,
      'minutes',
    );
    return (
      lastSessionEndTime.format('HH:mm') <
      potentialSessionEndTime.format('HH:mm')
    );
  }

  // timesValid means all start and end times for each session are sequential
  @computed('date.sessions.@each.{startTime,endTime}', 'event.slotLength')
  get timesValid() {
    let minDuration = this.event.get('slotLength') * 60;
    return this.date.sessions.every((session, index, sessions) => {
      if (session.endTime < session.startTime + minDuration) {
        // Session is too short, or ends before it starts.
        return false;
      }
      if (
        index > 0 &&
        session.startTime < sessions.objectAt(index - 1).endTime
      ) {
        // Session starts before the previous one ends.
        return false;
      }
      // Session times seem to be in order.
      return true;
    });
  }

  @computed(
    'date.sessions.@each.{startTime,endTime}',
    'event.{slotLength,slotFootprint}',
  )
  get slotCount() {
    return this.date.sessions.reduce((count, session) => {
      let startTime = moment
        .unix(session.startTime)
        .add(this.event.get('slotLength'), 'minutes');
      let endTime = moment.unix(session.endTime);
      count +=
        Math.max(
          0,
          Math.floor(
            endTime.diff(startTime, 'minutes') /
              this.event.get('slotFootprint'),
          ),
        ) + 1;
      return count;
    }, 0);
  }

  @action
  addSession() {
    let lastSession = this.date.sessions.lastObject;
    let newSession = this.store.createFragment('bookings/session', {
      startTime: moment
        .unix(lastSession.endTime)
        .add(defaultSessionGap, 'minutes')
        .unix(),
      endTime: moment
        .unix(lastSession.endTime)
        .add(defaultSessionGap + defaultSessionLength, 'minutes')
        .unix(),
    });
    this.date.sessions.addFragment(newSession);
  }

  @action
  deleteSession(session) {
    this.date.sessions.removeFragment(session);
  }
}
